<template>
	<!--
      作者：luoyiming
      时间：2019-10-25
      描述：订单信息
  -->
	<div class="pb50" v-loading="loading">
		<div class="product-content">
			<!--用户信息-->
			<div class="common-form">用户信息</div>
			<div class="table-wrap">
				<el-row>
					<el-col :span="8">
						<div class="pb16">
							<span class="gray9">用户ID：</span>
							{{ detail.user.user_id }}
						</div>
					</el-col>
					<el-col :span="8">
						<div class="pb16">
							<span class="gray9">用户昵称：</span>
							{{ detail.user.nickName }}
						</div>
					</el-col>
					<el-col :span="8">
						<div class="pb16">
							<span class="gray9">电话：</span>
							{{ detail.user.mobile }}
						</div>
					</el-col>
				</el-row>
			</div>
			
			<!--客户信息-->
			<div v-if="detail.delivery_type.value == 10">
				<div class="common-form mt16">客户信息</div>
				<div class="table-wrap">
					<el-row>
						<el-col>
							<div class="pb16">
								<span class="gray9">用户姓名：</span>
								{{ detail.address.name }}
							</div>
						</el-col>
						<el-col>
							<div class="pb16">
								<span class="gray9">联系电话：</span>
								{{ detail.address.phone }}
							</div>
						</el-col>
						<el-col>
							<div class="pb16">
								<span class="gray9">服务地址：</span>
								{{ detail.address.region.province }} {{ detail.address.region.city }}
								{{ detail.address.region.region }}
								{{ detail.address.detail }}
							</div>
							<!-- <div class="pb16" v-if="detail.delivery_status.value!=20">
								<el-button type="text" size="small" @click='changeAdd'> 修改地址</el-button>
							</div> -->
						</el-col>
						<el-col>
							<div class="pb16">
								<span class="gray9">预约时间：</span>
								{{ detail.address.createTime }}
							</div>
						</el-col>
						<el-col>
							<div class="pb16">
								<span class="gray9">备注：</span>
								{{ detail.buyer_remark }}
							</div>
						</el-col>
					</el-row>
				</div>
			</div>

			<!--商户信息-->
			<div class="common-form mt16">商户信息</div>
			<div class="table-wrap">
				<el-row>
					<el-col :span="8">
						<div class="pb16">
							<span class="gray9" v-if="detail.supplier">商户名称：{{ detail.supplier.name }}</span>
						</div>
					</el-col>
					<el-col :span="8">
						<div class="pb16">
							<span class="gray9">联系方式：</span>
						</div>
					</el-col>
				</el-row>
			</div>
			<!--城市站点信息-->
			<div class="common-form mt16">城市站点信息</div>
			<div class="table-wrap">
				<el-row>
					<el-col :span="8">
						<div class="pb16">
							<span class="gray9" v-if="detail.supplier">站点：{{ detail.supplier.name }}</span>
						</div>
					</el-col>
					<el-col :span="8">
						<div class="pb16">
							<span class="gray9">联系方式：</span>
						</div>
					</el-col>
				</el-row>
			</div>
			<!-- 订单信息 -->
			<div class="common-form">订单信息</div>
			<div class="table-wrap">
				<el-row>
					<el-col :span="8">
						<div class="pb16">
							<span class="gray9">创建时间：</span>
							{{ detail.createTime }}
						</div>
					</el-col>
					<el-col :span="8">
						<div class="pb16">
							<span class="gray9">支付金额：</span>
							{{ detail.order_price }}
						</div>
					</el-col>
					<el-col :span="8">
						<div class="pb16">
							<span class="gray9">支付总价：</span>
							{{ detail.pay_price }}
						</div>
					</el-col>
					<el-col :span="8">
						<div class="pb16">
							<span class="gray9">优惠金额：</span>
							{{ detail.fullreduce_money }}
						</div>
					</el-col>
					<el-col :span="8">
						<div class="pb16">
							<span class="gray9">技师车费：</span>
							{{ detail.express_price }}
						</div>
					</el-col>
					<el-col :span="8">
						<div class="pb16">
							<span class="gray9">全程距离：</span>

						</div>
					</el-col>
					<el-col :span="8">
						<div class="pb16">
							<span class="gray9">加钟次数：</span>

						</div>
					</el-col>
					<el-col :span="8">
						<div class="pb16">
							<span class="gray9">加钟总数：</span>

						</div>
					</el-col>
					<el-col :span="8">
						<div class="pb16">
							<span class="gray9">补充费用：</span>
							{{ detail.coupon_money }}
						</div>
					</el-col>					
				</el-row>
			</div>
			<!--买家留言-->
			<div class="common-form mt16">买家留言</div>
			<div class="table-wrap">
				<!-- <el-row>
					<el-col :span="8">
						<div class="pb16">
							<span class="gray9">联系方式：</span>
						</div>
					</el-col>
				</el-row> -->
			</div>
		</div>
		<changeAddress :isChange="isChange" :addressData="addressData" @closeDialog='closeAddress'></changeAddress>
		<!-- 修改技师子组件 -->
		<!-- <modify :isModify="isModify" ref="modify" @closeDialog='close($event)'></modify> -->
	</div>
</template>

<script>
	import OrderApi from '@/api/order.js';
	import changeAddress from '@/components/order/changeAddress.vue';	
	import {
		deepClone,
	} from '@/utils/base.js';
	export default {
		components: {
			changeAddress
		},
		data() {
			return {
				// 技师是否显示
				isModify: false,
				/*是否加载完成*/
				loading: true,
				/*订单数据*/
				detail: {
					pay_status: [],
					pay_type: [],
					delivery_type: [],
					user: {},
					address: [],
					product: [],
					order_status: [],
					extract: [],
					extract_store: [],
					express: [],
					delivery_status: [],
					extractClerk: []
				},
				/*是否打开添加弹窗*/
				open_add: false,
				/*一页多少条*/
				pageSize: 20,
				/*一共多少条数据*/
				totalDataNumber: 0,
				/*当前是第几页*/
				curPage: 1,			
				extract_form: {
					order: {
						extract_status: 1
					}
				},
				order: {},
				delivery_type: 0,
				isChange: false,
				addressData: {
					name: '',
					phone: '',
					province_id: 0,
					city: '',
					city_id: 0,
					region: '',
					region_id: 0,
					region: {
						province: '',
						province_id: 0,
						city: '',
						city_id: 0,
						region: '',
						region_id: 0,
						detail: '',
						username: '',
					},
				},
				uses:'',
				user_id:'',			
			}
		},
		created(e) {
			/*获取列表*/
			this.getParams();
		},
		methods: {
			modifys(){
				console.log(this.$route.query.orderId,'修改技师')
				this.$router.push({
				  path: '/order/order/some',
				  query: {
				    orderId: this.$route.query.orderId,
					user_id:this.user_id
				  }
				});
			},
			next() {
				if (this.active++ > 4) this.active = 0;
			},
			/*获取参数*/
			getParams() {
				let self = this;
				// 取到路由带过来的参数
				const params = this.$route.query.orderId;
				OrderApi.orderdetail({
							orderId: params
						},
						true
					)
					.then(data => {
						self.loading = false;
						self.detail = data.data.detail;
						self.addressData = self.detail.address;
						// self.username = self.detail.username
						self.user_id = self.detail.waiter_user_id
						self.uses = self.detail.username
					})
					.catch(error => {
						self.loading = false;
					});
			},

			changeAdd() {
				this.isChange = true;
			},
			closeAddress(e) {
				let self = this;
				if (e == false) {
					self.isChange = false;
					console.log(e)
					return false
				}
				let params = e.params;
				console.log(params)
				params.orderId = self.$route.query.orderId
				OrderApi.updateAddress(params,
						true
					)
					.then(data => {
						self.$message({
							message: '修改成功',
							type: 'success'
						});
					})
					.catch(error => {

					});
				self.isChange = false;
			}

		}
	};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/part/order.vue